import axiosClient from './axios.client';

export async function getReturnsCatalogApi() {
  return axiosClient.get('/demo-assistants/returns/catalog');
}

export async function getRecruitingCatalogApi() {
  return axiosClient.get('/demo-assistants/recruiting/catalog');
}

export async function getPersonalCatalogApi() {
  return axiosClient.get('/demo-assistants/personal/catalog');
}

export async function getDeskCatalogApi() {
  return axiosClient.get('/demo-assistants/desk/catalog');
}

/** Hybrid demos enabled for Host (platform apex = all; tenant = metadata). */
export async function getPublicHybridDemosApi(host) {
  const params = {};
  if (host) params.host = host;
  else if (typeof window !== 'undefined' && window.location?.host) {
    params.host = window.location.host;
  }
  return axiosClient.get('/demo-assistants/public-demos', { params });
}

/** Known demo registry (admin UI). */
export async function getHybridDemoRegistryApi() {
  return axiosClient.get('/demo-assistants/registry');
}

export async function adviseDemoAssistantApi(playbook, body = {}) {
  const key = String(playbook || '').toLowerCase();
  const pathByPlaybook = {
    recruiting: '/demo-assistants/recruiting/advise',
    '1+3': '/demo-assistants/recruiting/advise',
    hiring: '/demo-assistants/recruiting/advise',
    returns: '/demo-assistants/returns/advise',
    return: '/demo-assistants/returns/advise',
    rma: '/demo-assistants/returns/advise',
    'personal-assistant': '/demo-assistants/personal/advise',
    personal: '/demo-assistants/personal/advise',
    'desk-agent': '/demo-assistants/desk/advise',
    desk: '/demo-assistants/desk/advise',
    'desk-continuum': '/demo-assistants/desk/advise',
    'home-search': '/demo-assistants/home-search/advise',
    realestate: '/demo-assistants/home-search/advise',
    'home-search-advisor': '/demo-assistants/home-search/advise',
    'listing-agent': '/demo-assistants/listings/advise',
    listings: '/demo-assistants/listings/advise',
  };
  const path = pathByPlaybook[key] || `/demo-assistants/${encodeURIComponent(key)}/advise`;
  return axiosClient.post(path, body);
}
